import { Checkbox } from 'antd';
import styled from 'styled-components';

export const BenefitsContainer = styled(Checkbox.Group)`
	display: flex;
	width: 100%;
	align-items: center;
	padding: 20px;
	background: #f9fafb;
	flex-wrap: wrap;
	margin: 0;
`;
